import { DistributorPromiseThunkAction } from '../../types';
import { getServiceEnterpriseId } from '../entities/services/selectors';
import { fetchProductsFailed, fetchProductsStarted, fetchProductsSucceeded } from './reducer';

export const fetchProducts =
    (serviceId: string): DistributorPromiseThunkAction<string> =>
    async (dispatch, getState, { repositories, loggerService }) => {
        const state = getState();
        try {
            dispatch(fetchProductsStarted({ serviceId }));
            const enterpriseId = getServiceEnterpriseId(state, { serviceId });
            if (enterpriseId == null) {
                loggerService.log('missing-enterprise-id', "Couldn't find enterpriseId for service", { serviceId });
                throw Error("Couldn't find enterpriseId for service");
            }
            const { products } = await repositories.products.getAll({ serviceId });
            dispatch(fetchProductsSucceeded({ products, serviceId, enterpriseId }));
        } catch (error) {
            dispatch(fetchProductsFailed({ serviceId }));
            loggerService.log('products-fetch-failed', 'Failed fetching products for service', { serviceId });
            throw error;
        }
        return serviceId;
    };
